import createVueComponent from '../createVueComponent';

const Tag = createVueComponent('TagIcon', [
  [
    'path',
    {
      d:
        'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z',
    },
  ],
  ['line', { x1: '7', y1: '7', x2: '7.01', y2: '7' }],
]);

export default Tag;
